<template>
  <div class="register">
    <h2>会员登陆</h2>
    <form class="form">
      <input type="text" placeholder="请输入您的用户名" ref="user">
      <input type="password" placeholder="请输入您的密码" ref="password">
      <input type="button" value="立即登陆" @click="login()">
    </form>
    <div class="toggle">
      <router-link to="/entry/register" tag="span" class="goLogin">
        立即注册
      </router-link>
      <span class="toggle-tip">| 忘记密码</span> 
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  methods: {
    login: function () {
      let user = this.$refs.user.value,
          password = this.$refs.password.value,
          localUser = localStorage.getItem('user') || '-1',
          localPassword = localStorage.getItem('password') || '-1'
      console.log(typeof password)
      if (user === localUser && password === localPassword) {
        alert('登陆成功！')
        this.$router.push('/mall/pay')
      } else {
        alert('账号或密码错误')
      }
    }
  }
}
</script>

<style scoped>
.register {
  text-align: center;
  background-color: #fff;
  height: 100%;
}
.register > h2 {
  font-size: 30px;
  color: #fff;
  line-height: 72px;
  background-color: #ff574e;
}
.form {
  display: flex;
  flex-flow: column nowrap;
  padding: 44px 210px 0;
}
.form input{
  padding: 10px;
  border: 1px solid #c0c0c0;
  margin-bottom: 24px;
  font-size: 18px;
}
.form input[type=button]{
  color: #fff;
  background-color: #ff574e;
}
.form input:last-child {
  margin: 34px 0;
}
.getCode {
  display: flex;
}
.send {
  min-width: 100px;
  cursor: pointer;
}
.getCode > p{
  font-size: 20px;
  color: #ff574e;
  line-height: 42px;
  padding-left: 20px;
}
.toggle {
  padding: 0 0 40px;
}
.goLogin {
  font-size: 20px;
  cursor: pointer;
}
.goLogin:hover{
  color: #ff574e;
}
.toggle-tip {
  font-size: 20px;
}
@media (max-width: 1199px) {
  .form {
    padding: 24px 110px 0;
  }
  .form input:last-child {
    margin: 14px 0;
  }
}
@media screen and (max-width: 801px){
  .form {
    padding: 24px 10px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/userEntry/login.vue